import { RebuildDomainMutation, RebuildDomainMutationVariables } from 'gql/graphql'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { REBUILD_DOMAIN } from './mutation'
import { UseRebuildDomain, UseRebuildDomainProps } from './types'

export const useRebuildDomain = ({ name }: UseRebuildDomainProps): UseRebuildDomain => {
  const { t } = useTranslation('features/domain')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<
    RebuildDomainMutationVariables,
    RebuildDomainMutation
  >({
    mutation: REBUILD_DOMAIN,
    onCompleted: async (data: RebuildDomainMutation) => {
      const { rebuildDomain } = data

      if (rebuildDomain) {
        const { errors } = rebuildDomain

        if (errors && errors.length > 0) {
          enqueueSnackbar(t('rebuild.action.error', { domainName: name }), { variant: 'error' })
        }
      } else {
        enqueueSnackbar(t('rebuild.action.success', { domainName: name }), { variant: 'success' })
      }
    },
    queriesToInvalidate: [
      'getDomainsForTable',
      'getAlertsForDomainsTable',
      'getAdUnitsForTable',
      'getAlertsForAdUnitsTable',
    ],
  })

  const rebuildDomain: UseRebuildDomain['rebuildDomain'] = id => void mutateAsync({ input: { id } })

  return { loading, rebuildDomain }
}
